import React, { useState } from 'react';

import CardLayout from '@magoosh/layouts/card';
import { FontAwesomeIcon } from '@magoosh/lib/icons';
import useAuthenticityToken from '@magoosh/utils/use_authenticity_token';
import { paths } from 'config/path_helpers';
import fetch from 'utilities/fetch';

import colors from '@magoosh/lib/styles/colors.module.scss';

export default (props) => {
  const authenticityToken = useAuthenticityToken();
  const [isSwitching, setIsSwitching] = useState(false);

  const switchTo2026TOEFL = () => {
    setIsSwitching(true);

    fetch('/profile/exam_version', {
      method: 'PUT',
      body: JSON.stringify({
        authenticityToken,
        exam_version: '2026_toefl'
      })
    }).then(() => window.location.reload());
  };

  return (
    <CardLayout.Card className="d-flex flex-1" style={{ gap: 30 }}>
      <div
        className="align-items-center d-flex flex-none justify-content-center"
        style={{
          background: 'linear-gradient(to right, #26B67C, #9B51E0)',
          borderRadius: '50%',
          boxShadow: 'rgba(0, 0, 0, 0.15) 0px 4px 24px 0px, inset rgba(0, 0, 0, 0.15) 0px 0px 0px 3px',
          color: '#fff',
          height: 60,
          paddingTop: 3,
          width: 60
        }}
      >
        <FontAwesomeIcon icon="bell" style={{ fontSize: '1.5em' }} />
      </div>

      <div className="d-flex flex-column">
        <div className="text-gray-darker u-margin-V-xxs">
          <strong>You're studying for an outdated version of the TOEFL!</strong>
        </div>

        <div className="align-items-md-center d-flex flex-column flex-md-row gap-s">
          <a
            className="text-bold"
            onClick={isSwitching ? null : switchTo2026TOEFL}
            style={{ color: isSwitching ? colors.grayLight : colors.purple }}
          >
            Switch to the 2026 TOEFL {isSwitching && <>...</>}
          </a>
        </div>
      </div>
    </CardLayout.Card>
  );
};
